import { useState, useCallback } from "react";
import { useNotifications } from "@/hooks/useNotifications";
import { userInfoRepository } from "@/services/userInfoRepository";

export const useNotificationManagement = () => {
  const [isPushNotificationEnabled, setIsPushNotificationEnabled] = useState(false);
  const [isVisiblePermissionAlert, setIsVisiblePermissionAlert] = useState(false);
  const { permission, isSupported, requestPermission } = useNotifications();
  const { isEnabledPushNotifications, setIsEnabledPushNotifications } = userInfoRepository;

  const handleEnableNotifications = useCallback(async () => {
    const isEnabled = isEnabledPushNotifications();
    
    if (isEnabled) {
      setIsPushNotificationEnabled(false);
      setIsEnabledPushNotifications(false);
      return;
    }

    const result = await requestPermission();
    
    if (result === "granted") {
      setIsPushNotificationEnabled(true);
      setIsEnabledPushNotifications(true);
    } else {
      setIsVisiblePermissionAlert(true);
      setIsPushNotificationEnabled(false);
      setIsEnabledPushNotifications(false);
    }
  }, [isEnabledPushNotifications, setIsEnabledPushNotifications, requestPermission]);

  const closePermissionAlert = useCallback(() => {
    setIsVisiblePermissionAlert(false);
  }, []);

  return {
    isPushNotificationEnabled,
    setIsPushNotificationEnabled,
    isVisiblePermissionAlert,
    permission,
    isSupported,
    requestPermission,
    handleEnableNotifications,
    closePermissionAlert,
  };
}; 